import CRMPermission from '@/models/enums/permissions/CRMPermission'
import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/seo/meta',
    name: RouteName.SeoPageMetaList,
    component: () => import('@/pages/Seo/PageMeta/PageMetaList'),
    meta: {
      permissions: [CRMPermission.Seo],
      breadcrumb: {
        label: 'SЕО страниц',
        parent: RouteName.Settings,
      },
    },
  },
  {
    path: '/seo/meta/create',
    name: 'seoPageMetaCreate',
    component: () => import('@/pages/Seo/PageMeta/PageMetaCreate'),
    meta: {
      permissions: [CRMPermission.Seo],
      breadcrumb: {
        label: 'Новая SЕО запись',
        parent: RouteName.SeoPageMetaList,
      },
    },
  },
  {
    path: '/seo/meta/:id',
    name: 'seoPageMetaEdit',
    component: () => import('@/pages/Seo/PageMeta/PageMetaSingle'),
    props: { isEdit: false },
    meta: {
      permissions: [CRMPermission.Seo],
      breadcrumb: {
        label: 'Редактирование SЕО записи',
        parent: RouteName.SeoPageMetaList,
      },
    },
  },
]
